import React, { useState, useEffect } from 'react';
import styles from './Body.module.scss';
import img1 from '../../assets/bodyCarousel.png';
import img2 from '../../assets/bodyCarousel2.png';
import img3 from '../../assets/bodyCarousel3.png';

const images = [img1, img2, img3];

function Body() {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex(prev => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className={styles.body}>
      {images.map((img, idx) => (
        <img
          key={idx}
          src={img}
          alt={`Slide ${idx + 1}`}
          className={`${styles.slide} ${idx === activeIndex ? styles.active : ''}`}
        />
      ))}
    </div>
  );
}

export default Body;